import {useEffect} from "react";

interface ISwipeEvent {
    delta: number;
    event: MouseEvent;
}

interface IProps {
    element?: HTMLElement | null;
    onSwipeLeft?: (event: ISwipeEvent) => void;
    onSwipeRight?: (event: ISwipeEvent) => void;
    onSwipeUp?: (event: ISwipeEvent) => void;
    onSwipeDown?: (event: ISwipeEvent) => void;
    disable?: boolean;
}

export const useMouseSwipe = (props: IProps) => {
    useEffect(() => {
        if (props.disable) {
            return;
        }

        let startX = -1;
        let startY = -1;
        let endX = -1;
        let endY = -1;

        const resetValues = () => {
            startX = -1;
            endX = -1;
            startY = -1;
            endY = -1;
        };

        const onMouseDown = (event: MouseEvent) => {
            startX = event.clientX;
            startY = event.clientY;
        };

        const onMouseUp = (event: MouseEvent) => {
            endX = event.clientX;
            endY = event.clientY;
            const diffX = endX - startX;
            const diffY = endY - startY;

            if (Math.abs(diffX) > Math.abs(diffY)) {
                if (diffX > 0) {
                    props.onSwipeRight?.({
                        delta: diffX,
                        event
                    });
                } else {
                    props.onSwipeLeft?.({
                        delta: -diffX,
                        event
                    });
                }
            } else {
                if (diffY > 0) {
                    props.onSwipeDown?.({
                        delta: diffY,
                        event
                    });
                } else {
                    props.onSwipeUp?.({
                        delta: -diffY,
                        event
                    });
                }
            }

            resetValues();
        };

        props.element?.addEventListener("mousedown", onMouseDown, true);
        props.element?.addEventListener("mouseup", onMouseUp, true);

        return () => {
            props.element?.removeEventListener("mousedown", onMouseDown, true);
            props.element?.removeEventListener("mouseup", onMouseUp, true);
        };
    }, [props.element, props.disable]);
};
import {useEffect} from "react";

interface ISwipeEvent {
    delta: number;
    event: MouseEvent;
}

interface IProps {
    element?: HTMLElement | null;
    onSwipeLeft?: (event: ISwipeEvent) => void;
    onSwipeRight?: (event: ISwipeEvent) => void;
    onSwipeUp?: (event: ISwipeEvent) => void;
    onSwipeDown?: (event: ISwipeEvent) => void;
    disable?: boolean;
}

export const useMouseSwipe = (props: IProps) => {
    useEffect(() => {
        if (props.disable) {
            return;
        }

        let startX = -1;
        let startY = -1;
        let endX = -1;
        let endY = -1;

        const resetValues = () => {
            startX = -1;
            endX = -1;
            startY = -1;
            endY = -1;
        };

        const onMouseDown = (event: MouseEvent) => {
            startX = event.clientX;
            startY = event.clientY;
        };

        const onMouseUp = (event: MouseEvent) => {
            endX = event.clientX;
            endY = event.clientY;
            const diffX = endX - startX;
            const diffY = endY - startY;

            if (Math.abs(diffX) > Math.abs(diffY)) {
                if (diffX > 0) {
                    props.onSwipeRight?.({
                        delta: diffX,
                        event
                    });
                } else {
                    props.onSwipeLeft?.({
                        delta: -diffX,
                        event
                    });
                }
            } else {
                if (diffY > 0) {
                    props.onSwipeDown?.({
                        delta: diffY,
                        event
                    });
                } else {
                    props.onSwipeUp?.({
                        delta: -diffY,
                        event
                    });
                }
            }

            resetValues();
        };

        props.element?.addEventListener("mousedown", onMouseDown, true);
        props.element?.addEventListener("mouseup", onMouseUp, true);

        return () => {
            props.element?.removeEventListener("mousedown", onMouseDown, true);
            props.element?.removeEventListener("mouseup", onMouseUp, true);
        };
    }, [props.element, props.disable]);
};
